import {
  PREGNANT_AND_NEWBORN_ABOUT_CHILD_STEP,
  PREGNANT_AND_NEWBORN_ABOUT_YOU_STEP,
  PREGNANT_AND_NEWBORN_PRICE_STEP,
} from "Components/Features/CheckPrice/Products/LifeProducts/PregnantAndNewborn/pregnantAndNewbornSteps";

import { FormStates } from "Store/priceCalculation/priceCalculationInterfaces";

export function mapPregnantAndNewbornToForm(
  existingState: Record<string, any>,
  localStorageData?: Record<string, any>,
): FormStates {
  if (!localStorageData) {
    return {};
  }
  const formStates: FormStates = {};
  Object.entries(localStorageData).forEach(([key, value]) => {
    switch (key) {
      case PREGNANT_AND_NEWBORN_ABOUT_YOU_STEP.id:
        formStates[PREGNANT_AND_NEWBORN_ABOUT_YOU_STEP.id] = {
          parentGuardian: value.parentGuardian,
          isScandinavianCitizen: value.isScandinavianCitizen,
          isStayingInNorwayForMoreThanFiveYears:
            value.isStayingInNorwayForMoreThanFiveYears,
          pep: value.pep,
        };
        return;
      case PREGNANT_AND_NEWBORN_ABOUT_CHILD_STEP.id:
        formStates[PREGNANT_AND_NEWBORN_ABOUT_CHILD_STEP.id] = {
          childBorn: value.childBorn,
          multipleChildren: value.multipleChildren,
          birthDate: value.birthDate,
        };
        return;
      case PREGNANT_AND_NEWBORN_PRICE_STEP.id:
        const { coverage } = value;
        if (coverage) {
          formStates[PREGNANT_AND_NEWBORN_PRICE_STEP.id] = {
            coverage,
          };
        }
        return;
      default:
        return;
    }
  });
  return formStates;
}
